// The `dev` pack (spec v3 §3.3): Forgejo/GitHub issues and pull requests.
import { Rocket } from 'lucide-react'
import { registerPack } from './index'
import { gitIssueKind, pullRequestKind } from '@/kinds/git'
import { agentRunKind } from '@/kinds/agentrun'

export const devPack = registerPack({
  name: 'dev',
  title: 'Dev',
  description: 'issues, pull requests and reviews from Forgejo / GitHub',
  kinds: [gitIssueKind, pullRequestKind, agentRunKind],
  // the Graph is the hub (2026-10-10): the old Board, Reviews, Runs, Issues, Overview and
  // Infrastructure pages are views of it now (MERGED_INTO keeps their stored app ids)
  // Infrastructure (2026-10-23) moved to its own pack on 2026-10-31 (packs/infra.ts)
  nav: [{ to: '/dev/releases', label: 'Releases', icon: '🚀', Icon: Rocket, key: 'e' }],
  // a dev workspace reads as a dev workflow: its own section first, no calendar or weekly review
  layout: {
    section: 'dev',
    first: true,
    hides: ['upcoming', 'review'],
    adopts: ['prime', 'agents', 'graph'],
    order: ['graph', 'prime', 'agents', '/dev/releases'],
  },
})
